import { Component, ElementRef, viewChild, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { ClassesApiServiceService } from './classes-api-service.service';
import { ToasterService } from '../../providers/toaster/toaster.service';
import { finalize, Observable, take } from 'rxjs';
import { ConfomerService } from '../../providers/confomer/confomer.service';
import { Store } from '@ngrx/store';
import { PreventEscCloseDirective } from '../../utils/prevent-esc-close.directive';
import { PaginationComponent } from "../../components/pagination/pagination.component";
import { LoaderComponent } from "../../providers/loader.component";
import { debounce } from 'lodash';
import { CascadingSelectServiceService } from '../services/cascading-select-service.service';
import { FilterBaseAccessService } from '../../auth/filterbase-access';
import { Router } from '@angular/router';

const nameValidationPattern = /^[A-Za-z0-9& -]+$/;

function nameInputValidator(control: AbstractControl): ValidationErrors | null {
  const rawValue = control.value;

  if (rawValue === null || rawValue === undefined) {
    return { required: true };
  }

  const value = String(rawValue);
  const trimmedValue = value.trim();

  if (!value || trimmedValue.length === 0) {
    if (value.length > 0) {
      return { whitespaceOnly: true };
    }

    return { required: true };
  }

  if (trimmedValue.length < 2) {
    return { minlength: { requiredLength: 2, actualLength: trimmedValue.length } };
  }

  if (trimmedValue.length > 50) {
    return { maxlength: { requiredLength: 50, actualLength: trimmedValue.length } };
  }

  if (!nameValidationPattern.test(trimmedValue)) {
    return { pattern: { requiredPattern: 'Alphabets, numbers, spaces, hyphen, ampersand', actualValue: trimmedValue } };
  }

  return null;
}

@Component({
  selector: 'app-classes-list',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, ReactiveFormsModule, PreventEscCloseDirective, PaginationComponent, LoaderComponent],
  templateUrl: './classes-list.component.html',
  styleUrl: './classes-list.component.css'
})
export class ClassesListComponent {
  @ViewChild('modalClasses') modalClasses!: ElementRef<HTMLDialogElement>;
  @ViewChild('batchInput') batchInput!: ElementRef
  addBatchText = ''
  addedBatchArray: string[] = []
  deapertmentList$!: Observable<any>
  classesList:any[] = [];
  classFrom!: FormGroup
  batchNameControl = new FormControl('', nameInputValidator);
  batchError: string | null = null;
  isreqSent: boolean = false
  isFetching: boolean = false;
  currentPage: any = null;
  searchStr: string = '';
  paginationData: any = {};
  departmentList: any[] = []

  create_class: boolean = false;
  class_list: boolean = false;
  view_class: boolean = false;
  edit_class: boolean = false;
  delete_class: boolean = false;
  class_performance: boolean = false;
  class_communication: boolean = false;

  constructor(private classApiService: ClassesApiServiceService, private toasterService: ToasterService,
    private conformerService: ConfomerService , private fb: FormBuilder,private store: Store,private cascadedService: CascadingSelectServiceService, private access: FilterBaseAccessService, private router: Router) {
    this.classFrom = this.fb.group({
      id: [''],
      class_name: ['', [nameInputValidator]],
      department_id: ['', Validators.required],
      batch_id: [[], Validators.required]
    });
    this.create_class = this.access.checkaccessforfiltersandactions('create class');
    this.class_list = this.access.checkaccessforfiltersandactions('class list');
    this.view_class = this.access.checkaccessforfiltersandactions('view class');
    this.edit_class = this.access.checkaccessforfiltersandactions('edit class');
    this.delete_class = this.access.checkaccessforfiltersandactions('delete class');
    this.class_performance = this.access.checkaccessforfiltersandactions('class performance');
    this.class_communication = this.access.checkaccessforfiltersandactions('class communication');
  }


  ngOnInit() {
    this.deapertmentList$ = this.cascadedService.departments$;
    this.getClassList();
  }

  getClassList() {
    this.isFetching = true;
    this.classApiService.getClassesList(this.currentPage,this.searchStr)
    .pipe(finalize(() => { this.isFetching = false; }))
    .subscribe({
      next: (res: any) => {
        if (res.status == 'success') {
          this.classesList = res?.data ?? [];
          this.paginationData = res.pagination || {};
        }
      },
      error: (err: any) => {
        console.error('HTTP error:', err);
      }
    })
  }

    search = debounce(() => {
      this.getClassList();
      return;
    }, 500);

  onsubmit() {
    const trimmedClassName = this.getTrimmedValue(this.classFrom.get('class_name')?.value);
    this.classFrom.patchValue({ class_name: trimmedClassName });

    if (this.classFrom.invalid) {
      this.classFrom.markAllAsTouched()
      this.batchNameControl.markAsTouched();
      this.toasterService.setToaster('error', 'Error', 'Please fill all required fields')
      return
    }

    console.log(this.classFrom.value);
    

    const id = this.classFrom.value.id
    const data = {...this.classFrom.value}
    data.class_name = this.getTrimmedValue(data.class_name)
    delete data.id
    this.isreqSent = true
    if (id) {
      this.classApiService.updateClass(id, data).pipe(finalize(() => { this.isreqSent = false; })).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toasterService.setToaster('success', 'Success', res.message || 'Class updated successfully');
            this.closeModal()
            this.getClassList()
          }
        },
        error: (err: any) => {
          console.error('HTTP error:', err);
        }
      })
    } else {
      this.classApiService.createClass(data).pipe(finalize(() => { this.isreqSent = false; })).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toasterService.setToaster('success', 'Success', res.message || 'Class added successfully');
            this.closeModal()
            this.getClassList()
          }
        },
        error: (err: any) => {
          console.error('HTTP error:', err);
        }
      })
    }
  }

  async deleteClass(id: any) {
    if (!id) {
      return
    }
    const confirm = await this.conformerService.Open('Confirm Delete', 'Are you sure you want to delete this class?');
    if (confirm) {
      this.classApiService.deleteClass(id).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toasterService.setToaster('success', 'Success', res.message || 'Class deleted successfully');
            this.getClassList()
          }
        },
        error: (err: any) => {
          console.error('HTTP error:', err);
        }
      })
    }
  }


  addBatch() {
    this.onBatchInput();

    if (this.batchNameControl.invalid) {
      return;
    }

    const trimmedValue = this.getTrimmedValue(this.batchNameControl.value);
    this.batchError = null;
    this.addedBatchArray.push(trimmedValue.replace(/ /g, '-'));
    this.batchNameControl.reset('');
    if (this.batchInput?.nativeElement) {
      this.batchInput.nativeElement.value = '';
    }

    this.classFrom.patchValue({
      batch_id: this.addedBatchArray
    })
  }

  removeBatch(batch: number) {
    this.addedBatchArray.splice(batch, 1)
    this.classFrom.patchValue({
      batch_id: this.addedBatchArray
    })
  }

  getTrimmedValue(value: any): string {
    return typeof value === 'string' ? value.trim() : '';
  }

  onBatchInput(): void {
    const rawValue = this.batchNameControl.value ?? this.batchInput?.nativeElement?.value ?? '';
    const trimmedValue = this.getTrimmedValue(rawValue);

    this.batchNameControl.setValue(trimmedValue, { emitEvent: false });
    this.batchNameControl.markAsTouched();

    this.batchError = this.getFieldValidationMessage(this.batchNameControl, 'Batch name');
  }

  getFieldValidationMessage(control: AbstractControl, fieldName: string): string | null {
    if (control.errors?.['whitespaceOnly']) {
      return `${fieldName} cannot contain only spaces`;
    }

    if (control.errors?.['required']) {
      return `${fieldName} is required`;
    }

    if (control.errors?.['minlength']) {
      return `${fieldName} must be at least 2 characters`;
    }

    if (control.errors?.['maxlength']) {
      return `${fieldName} must be at most 50 characters`;
    }

    if (control.errors?.['pattern']) {
      return `${fieldName} can only contain letters, numbers, spaces, hyphen, and ampersand`;
    }

    return null;
  }


  openModal(data?: any) {
    this.classFrom.reset();
    this.batchNameControl.reset('');
    this.batchError = null;
    console.log(data);
    
    if (data) {
      this.classFrom.patchValue({
        id: data.id,
        class_name: data.class_name,
        department_id: data.department_id,
        batch_id: data.batch.map((batch: any) => batch.batch_name)
      });
      this.addedBatchArray = data.batch.map((batch: any) => batch.batch_name)
    }
    this.modalClasses.nativeElement.showModal();
  }

  closeModal() {
    this.classFrom.reset();
    this.batchNameControl.reset('');
    this.batchError = null;
    this.addedBatchArray = []
    this.modalClasses.nativeElement.close();
  }


  pageChange(event: any) {
    this.currentPage = event;
    this.getClassList();
  }

  openPerformance(id: number | string) {
    this.router.navigate(['/performance', 'class', id]);
  }

  openChat(id: number | string) {
    this.router.navigate(['/chats'], { queryParams: { type: 'class', id } });
  }

}
